module.exports = __webpack_public_path__ + "img/00_Sperrzone_iPad_P.90761379.jpg";